import _t from 'counterpart';

export interface ICommissionModelLevel {
  level: number | null;
  cpaAmount: number | null;
  cpaCurrency: string | null;
  volumeCommissionAmount: number | null;
  volumeCommissionCurrency: string | null;
  profitSharePercentage: number | null;
  propPurchaseFirstPercentage: number | null;
  propPurchaseSubsequentPercentage: number | null;
}

export interface ICommissionModel {
  id?: number;
  name: string;
  subCommissionModel: { id: string; name: string } | null;
  subCommissionModelId: number | null;
  greyLabelingEnabled: boolean;
  commissionModelLevels: Array<ICommissionModelLevel>;
  default: boolean;
}

export interface IUpdateCommissionModelParams {
  commissionModel: Omit<ICommissionModel, 'subCommissionModel' | 'default'>;
  id: number;
}

export const initialCommissionModelState: ICommissionModel = {
  name: '',
  subCommissionModel: null,
  subCommissionModelId: null,
  greyLabelingEnabled: false,
  commissionModelLevels: [],
  default: false,
};

export const initialCommissionModelLevel: ICommissionModelLevel = {
  level: 1,
  cpaAmount: null,
  cpaCurrency: null,
  volumeCommissionAmount: null,
  volumeCommissionCurrency: null,
  profitSharePercentage: null,
  propPurchaseFirstPercentage: null,
  propPurchaseSubsequentPercentage: null,
};

export enum CommissionType {
  CPA = 'CPA',
  VOLUME = 'VOLUME',
  PROFIT_SHARE = 'PROFIT_SHARE',
}

export enum ActionType {
  FTD = 'FTD',
  Trade = 'Trade',
}
